// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9f5cc2e","455":"3e4c9093","977":"18a79f08"}[chunkId] + ".chunk.js";
};